import { useDispatch } from "react-redux";

import { resetFilters, setFilter } from "..";

export const usePriceRemarkFilterActions = () => {
  const dispatch = useDispatch();

  const updateFilter = (payload: { key: string; value: unknown }) =>
    dispatch(setFilter(payload));

  const clearFilters = () => dispatch(resetFilters());

  return { updateFilter, clearFilters };
};
